var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.27228 17.3917C4.91452 17.7494 4.904 18.3596 5.27228 18.7278C5.63004 19.096 6.25086 19.0855 6.60862 18.7278L11.9961 13.3308L17.394 18.7278C17.7518 19.0855 18.3621 19.096 18.7198 18.7278C19.0986 18.3596 19.0881 17.7494 18.7198 17.3917L13.3324 11.9947L18.7198 6.60831C19.0881 6.25062 19.0986 5.62992 18.7198 5.27223C18.3621 4.90402 17.7518 4.91454 17.394 5.27223L11.9961 10.6692L6.60862 5.27223C6.25086 4.91454 5.63004 4.90402 5.27228 5.27223C4.904 5.62992 4.91452 6.25062 5.27228 6.60831L10.6702 11.9947L5.27228 17.3917Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/Cross.884adde8b4970464387a9d823eb6b446.svg";
export { ForwardRef as ReactComponent };